module.exports = __webpack_public_path__ + "static/fvd-maintenance-6116f40d2936c90f1220712130d2d61d.png";